

export const MainRace1 = () => {
    return (<>
        <div className="modal-body">
            <span>Princess Races este o secțiune dedicată turneelor organizate de Princess Casino sau de partenerii
                furnizori de jocuri. Verifică termenii fiecărei curse în parte pentru a descoperi cum poți participa
                și câștiga premii.</span>
            <p><strong>Cursa Principală</strong></p>
            <span>Promoţia este deschisă participării tuturor persoanelor fizice cu vârsta de peste 18 ani, cu
                capacitate deplină de exerciţiu si care au un cont activ si verificat pe website-ul
                PrincessCasino.ro, mai puțin jucătorilor participanți la Cursa Titanilor.</span>
            <span>Închiderea/Suspendarea/Restricționarea contului din orice motive descalifică utilizatorul din
                promoție.</span>
            <span>CURSA PRINCIPALĂ se desfășoară de la data de 22 Ianuarie 2021, orele 00:00, până la data de 31
                Ianuarie 2021, orele 23:59.</span>
            <span>Participare</span>
            <span>Sunt eligibile pentru această cursă toate sloturile, precum și jocurile din categoria “Cazinou
                Virtual”.</span>
            <span>Aduni puncte pe baza multiplicatorului fiecărei runde câștigate. De exemplu: pariezi 2 RON și câștigi
                5 RON, vei primi 2,5 puncte.</span>
            <span>Punctele se obțin doar la câștiguri mai mari sau egale cu miza.</span>
            <span>Pariul minim pentru această cursă este de 2 RON.</span>
            <span>Punctajul unui jucător este suma tuturor multiplicatorilor obținuți la jocurile eligibile, din
                pariuri realizate cu bani cash, în perioada desfășurării competiției.</span>
            <span>Poți obține un premiu în două feluri:</span>
            <ul>
                <li>Clasament<br/>Adună cât mai multe puncte și califică-te în top 200 pentru un premiu cash.</li>
            </ul>
            <span>Premii Clasament</span>
            <div className="terms-table">
                <div className="terms-table-header">
                    <div className="terms-table-row">
                        <div className="terms-table-data"><strong>Locul</strong></div>
                        <div className="terms-table-data"><strong>Premii Cursa Principala</strong></div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">1</div>
                        <div className="terms-table-data">10,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">2</div>
                        <div className="terms-table-data">7,500 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">3</div>
                        <div className="terms-table-data">5,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">4</div>
                        <div className="terms-table-data">3,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">5</div>
                        <div className="terms-table-data">2,500 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">6-7</div>
                        <div className="terms-table-data">2,250 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">8-12</div>
                        <div className="terms-table-data">2,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">13-22</div>
                        <div className="terms-table-data">1,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">23-28</div>
                        <div className="terms-table-data">750 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">29-38</div>
                        <div className="terms-table-data">500 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">39-53</div>
                        <div className="terms-table-data">250 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">54-73</div>
                        <div className="terms-table-data">200 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">74-98</div>
                        <div className="terms-table-data">150 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">99-100</div>
                        <div className="terms-table-data">125 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">101-125</div>
                        <div className="terms-table-data">100 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">126-150</div>
                        <div className="terms-table-data">80 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">151-175</div>
                        <div className="terms-table-data">50 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">176-200</div>
                        <div className="terms-table-data">20 RON</div>
                    </div>
                </div>
            </div>
            <ul>
                <li>Premii Instant<br/>/În fiecare zi, sunt acordate 20 de premii a câte 100 RON. Premiile sunt acordate
                    aleatoriu pe durata întregii zile, la fiecare 30 de minute, între 14:15 și 23:45. <br/>Te asiguri că
                        ești eligibil pentru premiul instant obținând cel puțin 10 puncte în ziua respectivă (după ora
                        00.00).
                </li>
            </ul>
            <span>Premiile vor fi acordate în balanța CASH, în următoarele 48 de ore de la încheierea competiției.</span>
            <span>Jucătorii vor fi anunțați pe email și SMS când au primit un premiu.</span>
            <span>În cazul în care este egalitate de puncte între doi jucători, suma totală rulată va fi folosită ca un
                criteriu de departajare. În situația în care este egalitate perfectă de puncte și de sumă totală
                rulată pe perioada promoției, premiul va fi împărțit între jucători.</span>
            <span>În cazuri de deconectare sau de probleme tehnice generale, toate rotirile afectate sunt anulate și
                excluse din promoție în scopuri de punctaj.</span>
            <span>Oferta respectă Termenii și Condițiile Princess Casino.</span>
            <span>Princess Casino își rezervă dreptul de a suspenda promoția pentru unul sau pentru toți jucătorii,
                fără explicații sau notificări prealabile, dacă promoția este folosită într-o manieră ce contravine
                Regulilor Organizatorului. În cazul unui litigiu cu un jucător, decizia Organizatorului va
                prevala.</span>
            <span>Princess Casino își rezervă dreptul de a exclude jucătorii care participă la promoții cu conturi
                multiple.</span>
            <span>Princess Casino își rezervă dreptul de a anula sau modifica termenii și condițiile acestei oferte
                fără notificare prealabilă.</span>
            <span>Pentru orice întrebări legate de prezenta promoție, utilizatorii sunt rugați să contacteze echipa de
                asistență la adresa de e-mail <a href="mailto:contact@princesscasino.ro">contact@princesscasino.ro</a>.</span>
        </div>
    </>)
}